import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import { ADMINPROMPTS, POST_CONTACT_US } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";
import arrorRight from "../../../assets/img/arrow-right.svg";
import { ADMINPROMPTSADD, ADMINPROMPTSEDIT } from "../../../util/path";
import Loading from "react-fullscreen-loading";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminContactUs = () => {
  const navigate = useNavigate();



  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);

  const [expandedRows, setExpandedRows] = useState([]);

  const [modalShow, setModalShow] = useState(false);
  const [supportDetail, setSupportDetail] = useState({});

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };

  // Re-run on text change
  const [contactList, setContactList] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  useEffect(() => {
    getListData();
  }, []);

  const toggleExpand = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const getListData = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", POST_CONTACT_US);
      if (response.res.status == 200) {
        setContactList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  // const handleDelete = async (supportId) => {
  //   const result = await MySwal.fire({
  //     title: "Are you sure want to delete Support request?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //   });
  //   if (result.isConfirmed) {
  //     setIsLoading(true);
  //     try {
  //       const response = await CallWithAuth(
  //         "DELETE",
  //         `${POST_SUPPORT}/${supportId}`
  //       );
  //       if (
  //         response?.res?.data?.statusCode === 200 ||
  //         response?.res?.data?.statusCode === 201
  //       ) {
  //         showToast("success", "Support Request has been deleted successfully");
  //         getSupportListData();
  //       } else {
  //         showToast("error", response?.res?.data?.message);
  //       }
  //       setIsLoading(false);
  //     } catch (error) {
  //       setIsLoading(false);
  //     }
  //   }
  // };

  const handleModal = (item) => {
    console.log("item", item);
    setModalShow(true);
    setSupportDetail(item);
  };
  const handleClose = () => {
    setModalShow(false);
    setSupportDetail({});
  };
  return (
    <>
      {modalShow && (
        <>
          <Modal show={modalShow} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <td>{supportDetail.name}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{supportDetail.email}</td>
                  </tr>
                  <tr>
                    <th>Phone</th>
                    <td>{supportDetail.phone}</td>
                  </tr>
                  <tr>
                    <th>Issue</th>
                    <td>{supportDetail.subject}</td>
                  </tr>
                  <tr>
                    <th>Issue Details</th>
                    <td>{supportDetail.subjectDetails}</td>
                  </tr>
                  {/* <tr>
                    <th>Image</th>
                    <td>
                      {supportDetail.image ? (
                        <img
                          src={supportDetail.image}
                          alt="Issue"
                          width={150}
                        />
                      ) : (
                        "No image available"
                      )}
                    </td>
                  </tr> */}
                  <tr>
                    <th>Image</th>
                    <td>
                      {supportDetail.image ? (
                        <a
                          href={supportDetail.image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="fas fa-eye"
                            style={{ fontSize: "20px", cursor: "pointer" }}
                          ></i>
                        </a>
                      ) : (
                        "No image available"
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {/* <PromptEditor
                                    field="background_info"
                                    promptValue={promptData?.background_info || ""}
                                    onChange={handlePromptInputChange}
                                    onTest={handleTestPrompt}
                                    onUpdate={handleUpdatePrompt}
                                    onCancel={handleChangePrompt}
                                    onReset={handleReset}
                                    cancelValue={reportgenerateData.background_info_update_prompt}
                                    promptResult={promptResult}
                                  /> */}
            </Modal.Footer>
          </Modal>
        </>
      )}

      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Contact us list</h1>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  <img src={patient} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="site_container">
          <div className="patient_form_block">
            <table className="table patient-row-details m-0">
              <thead>
                <tr>
                  <th width="15%">Name</th>
                  <th width="10%">Email</th>
                  <th width="10%">Phone</th>
                  <th width="20%">About Query</th>
                  {/* <th width="15%" className="text-center">
                    Action
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {/* {selector?.data?.length
                          ? selector?.data?.map((patient, index) => ( */}
                {Array.isArray(contactList) && contactList.length > 0 && (
                  <>
                    {contactList.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.name}</td>
                        <td>{item?.email}</td>
                        <td>{item?.phone || "N/A"}</td>
                        {/* <td>{item?.promtText || "N/A"}</td> */}
                        <td style={{ wordBreak: "break-word" }}>
                          {item?.message ? (
                            <>
                              {expandedRows.includes(index)
                                ? item.message
                                : item.message.slice(0, 100) +
                                  (item.message.length > 100
                                    ? "..."
                                    : "")}
                              {item.message.length > 100 && (
                                <button
                                  onClick={() => toggleExpand(index)}
                                  style={{
                                    marginLeft: 8,
                                    border: "none",
                                    background: "none",
                                    color: "blue",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {expandedRows.includes(index)
                                    ? "Show Less"
                                    : "Show More"}
                                </button>
                              )}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </td>

                        {/* <td>
                          {item?.image ? (
                            <img
                              alt="Image"
                              style={{ width: "50px", height: "50px" }}
                              src={item?.image}
                            />
                          ) : (
                            "N/A"
                          )}
                        </td> */}
                       
                        {/* <td
                          className="d-flex gap-3 text-center patient-informartion-action"
                          style={{ flexWrap: "wrap", justifyContent: "center" }}
                        >
                          <button
                            // onClick={() => setModalShow(true)}
                            onClick={() => handleModal(item)}
                            // onClick={() =>
                            //   navigate(`${ADMINPROMPTSEDIT}/${item?.id}`)
                            // }
                            className="edit"
                          >
                            <i className="fa-solid fa-info"></i>
                          </button>
                          <button
                            onClick={() => handleDelete(item?.id)}
                            className="edit"
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </td> */}
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            {contactList.length > 0 == 0 && (
              <h1 style={{ textAlign: "center" }}>No Support Request Found</h1>
            )}
          </div>
        </section>
      </div>
      <ToastContainer />
    </>
  );
};
export default AdminContactUs;
